import request from "@/utils/request";

export default function agentGetSocketsByDeviceId(params) {
    return request({
        url: `/device/socket/agentGetSocketsByDeviceId`,
        params: params
    })
}